jQuery( document ).ready( function($) {

	// slick slider
	$( '.slide-banner' ).slick({
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 3000,
		fade: true,
		dots: false,
		arrows: false,
	});

	// event slider
	$( '.event-slides' ).slick({
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 3000,
		fade: false,
		dots: true,
		arrows: false,
	});

	// reveal the menu
	$( '.j-show-menu' ).on( 'click', function(e) {
		e.preventDefault();

		$( this ).toggleClass( 'active' );
		$( '.navigation' ).toggleClass( 'slidein' );
	});

	// scroll to page sections
	$( '.navigation a[href^="#"]' ).on( 'click', function(event) {
		var target = $(this.getAttribute('href'));
		if( target.length ) {
		event.preventDefault();
			$( 'html, body' ).stop().animate({
				scrollTop: target.offset().top
			}, 1000);
		}
	});

	// Booking widget
	if ( $( 'body' ).hasClass( 'page-book-a-table' ) ) {
		$(function() {
			var widgetFrame = $("#rd-widget-frame");
			widgetFrame.load("https://7723fded-c4a4-4605-b717-6a890ecd2c71.resdiary.com/widget/Standard/PennyBlue/2200");
		});
	};

	if ( $( 'body' ).hasClass( 'page-afternoon-tea-carlisle' ) ) {
		$(function() {
			var widgetFrame = $("#rd-widget-frame");
			widgetFrame.load("https://booking.resdiary.com/widget/Standard/PennyBlue/10874");
		});
	};

	// Modal message
	// var $modal = $( '#popup-modal' ); //define your variables
	// var delay = 9000;

	//check if session variable exists.
	//If NOT then call your function.
	// if ( !sessionStorage.getItem( 'is_already_opened_once' ) ) { 
	// 	modalHandler($modal,delay);//call your function
	// }

	// function modalHandler($modal,delay){
		// $modal.foundation('open');
		// setTimeout(function(){
		// 	$modal.foundation( 'open' );
			//set the session_variable
			// sessionStorage.setItem( 'is_already_opened_once', true );
		// },delay);
	// }

	// message box
	if( getCookie( 'show_cookie_message' ) != 'no') {
		$( '#message_box' ).addClass( 'shown' );
	}

	$( '.message_box_close' ).click( function() {
		$( '#message_box' ).removeClass( 'shown' );
		setCookie( 'show_cookie_message', 'no' );
		return false;
	});

	function setCookie( cookie_name, value ) {
		document.cookie = cookie_name+ "=" + escape(value);
	}

	function getCookie( cookie_name ) {
		if ( document.cookie.length>0 ) {
			cookie_start = document.cookie.indexOf( cookie_name + "=" );

			if ( cookie_start != -1 ) {
				cookie_start = cookie_start + cookie_name.length+1;
				cookie_end = document.cookie.indexOf( ";",cookie_start );
				if ( cookie_end == -1 ) {
					cookie_end = document.cookie.length;
				}
				return unescape( document.cookie.substring( cookie_start,cookie_end ) );
			}
		}
		return "";
	}

	// footer message box
	if( newCookie( 'show_cookie_message' ) != 'no') {
		$( '#footer_msg' ).addClass( 'shown' );
	}

	$( '.footer_box_close' ).click( function() {
		$( '#footer_msg' ).removeClass( 'shown' );
		footCookie( 'show_cookie_message', 'no' );
		return false;
	});

	function footCookie( cookie_name, value ) {
		document.cookie = cookie_name+ "=" + escape(value);
	}

	function newCookie( cookie_name ) {
		if ( document.cookie.length>0 ) {
			cookie_start = document.cookie.indexOf( cookie_name + "=" );

			if ( cookie_start != -1 ) {
				cookie_start = cookie_start + cookie_name.length+1;
				cookie_end = document.cookie.indexOf( ";",cookie_start );
				if ( cookie_end == -1 ) {
					cookie_end = document.cookie.length;
				}
				return unescape( document.cookie.substring( cookie_start,cookie_end ) );
			}
		}
		return "";
	}

});